import {InitPage} from "../index";

declare var clientsPath;

class cdmHhIndex {
    constructor() {
    }

    initializeHTML() {
        const _this = this;
        $('.client_id').select2({
            placeholder: 'Search and Select Tenant',
            allowClear: true,
            width: '100%',
            ajax: {
                url: clientsPath
                },
            dropdownParent: $("#client-list"),
            templateSelection: _this.updateItemMetadata
          }); 

    }

    updateItemMetadata(e: any) {
        return e.text;
    }
}

declare global {
    interface Window {
        cdmHhIndex: cdmHhIndex;
    }
}

export function LoadPage() {
    InitPage("cdm_handhelds", () => {
        const cdm_hh = new cdmHhIndex();
         window.cdmHhIndex =  new cdmHhIndex();
         window.cdmHhIndex.initializeHTML();
    });
}
